import i18next from 'i18next';

i18next.addResources('es', 'projectCharts', {
  projectCharts: 'Gráficos de proyectos',
  projectsByCountry: 'Proyectos por país',
  projectsByStage: 'Proyectos por etapa',
  projectsBySector: 'Proyectos por Sector/Subsector',
  investmentBySector: 'Inversión por Sector/Subsector',
  status: 'Estado',
  numberOfProjects: 'Cantidad de Proyectos',
  subsector: 'Subsector',
  millionsUSD: 'Millones de USD',
  millions: 'millones',
  activeFilters: 'Filtros Activos:',
  country: 'País',
  stage: 'Etapa'
});

i18next.addResources('en', 'projectCharts', {
  projectCharts: 'Project Charts',
  projectsByCountry: 'Projects by Country',
  projectsByStage: 'Projects by Stage',
  projectsBySector: 'Projects by Sector/Subsector',
  investmentBySector: 'Investment by Sector/Subsector',
  status: 'Status',
  numberOfProjects: 'Number of Projects',
  subsector: 'Subsector',
  millionsUSD: 'Millions USD',
  millions: 'millions',
  activeFilters: 'Active Filters:',
  country: 'Country',
  stage: 'Stage'
});

i18next.addResources('pt', 'projectCharts', {
  projectCharts: 'Gráficos de projetos',
  projectsByCountry: 'Projetos por país',
  projectsByStage: 'Projetos por etapa',
  projectsBySector: 'Projetos por Setor/Subsetor',
  investmentBySector: 'Investimento por Setor/Subsetor',
  status: 'Estado',
  numberOfProjects: 'Número de Projetos',
  subsector: 'Subsetor',
  millionsUSD: 'Milhões USD',
  millions: 'milhões',
  activeFilters: 'Filtros Ativos:',
  country: 'País',
  stage: 'Etapa'
});
